import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RutasGlobales, RUTAS_GLOBALES } from '@app/routes/routes';

@Injectable({
  providedIn: 'root',
})
export class NavegacionService {
  private keyRutaActual: RutasGlobales = null;

  constructor(private readonly router: Router) {}

  navegar(keyRuta: RutasGlobales, parametros?: any[]) {
    this.keyRutaActual = keyRuta;
    const ruta = RUTAS_GLOBALES[keyRuta];
    if (!parametros) return this.router.navigate([ruta]);
    let rutaConParametros = ruta.toString();
    parametros.forEach((parametro) => {
      rutaConParametros = rutaConParametros.replace(/:[a-z]*/, parametro);
    });
    return this.router.navigate([rutaConParametros]);
  }
  navegarRelative(ruta: string, activatedRoute: ActivatedRoute) {
    return this.router.navigate([ruta], { relativeTo: activatedRoute });
  }
  getKeyRuta() {
    return this.keyRutaActual;
  }
}
